module.exports = __webpack_public_path__ + "static/media/wheat.c9fb1d97.svg";